import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { paymentMethodsService } from "../services/paymentMethod.service";

export const fetchPaymentMethods = createAsyncThunk("paymentMethod/fetchAll", async (_, thunkAPI) => {
  try {
    return await paymentMethodsService.getPaymentMethods();
  } catch {
    return thunkAPI.rejectWithValue("Failed to fetch payment methods.");
  }
});

export const fetchPaymentMethodById = createAsyncThunk("paymentMethod/fetchById", async (id, thunkAPI) => {
  try {
    return await paymentMethodsService.getPaymentMethodById(id);
  } catch {
    return thunkAPI.rejectWithValue("Failed to fetch payment method");
  }
});

export const addPaymentMethod = createAsyncThunk("paymentMethod/add", async (paymentMethod, thunkAPI) => {
  try {
    return await paymentMethodsService.createPaymentMethod(paymentMethod);
  } catch {
    return thunkAPI.rejectWithValue("Failed to create payment method");
  }
});

export const editPaymentMethod = createAsyncThunk("paymentMethod/edit", async ({ id, paymentMethod }, thunkAPI) => {
  try {
    return await paymentMethodsService.updatePaymentMethod(id, paymentMethod);
  } catch {
    return thunkAPI.rejectWithValue("Failed to update payment method");
  }
});

export const removePaymentMethod = createAsyncThunk("paymentMethod/remove", async (id, thunkAPI) => {
  try {
    await paymentMethodsService.deletePaymentMethod(id);
    return id;
  } catch {
    return thunkAPI.rejectWithValue("Failed to delete payment method");
  }
});

const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState: { paymentMethods: [], totalCount: 0, paymentMethod: null, loading: false, error: null, showModal: false, showDeleteModal: false },
  reducers: {
    openModal: (state) => { state.showModal = true },
    closeModal: (state) => { state.showModal = false },
    openDeleteModal: (state) => { state.showDeleteModal = true },
    closeDeleteModal: (state) => { state.showDeleteModal = false },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => { state.loading = false; state.paymentMethods = action.payload; })
      .addCase(fetchPaymentMethods.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchPaymentMethodById.fulfilled, (state, action) => { state.paymentMethod = action.payload; })
      .addCase(addPaymentMethod.pending, (state) => { state.loading = true })
      .addCase(addPaymentMethod.fulfilled, (state, action) => {
        state.paymentMethods = [action.payload, ...state.paymentMethods];
        state.loading = false; state.showModal = false;
      })
      .addCase(editPaymentMethod.pending, (state) => { state.loading = true })
      .addCase(editPaymentMethod.fulfilled, (state, action) => {
        const edited = action.meta.arg;
        state.paymentMethods = state.paymentMethods.map((p) =>
          p.paymentMethodId === edited.id ? { ...edited.paymentMethod, paymentMethodId: edited.id } : p
        );
        state.loading = false; state.showModal = false;
      })
      .addCase(removePaymentMethod.pending, (state) => { state.loading = true })
      .addCase(removePaymentMethod.fulfilled, (state, action) => {
        state.paymentMethods = state.paymentMethods.filter((p) => p.paymentMethodId !== action.payload);
        state.loading = false; state.showDeleteModal = false;
      })
      .addCase(removePaymentMethod.rejected, (state) => { state.loading = false });
  },
});

export const { openModal, closeModal, openDeleteModal, closeDeleteModal } = paymentMethodSlice.actions;
export default paymentMethodSlice.reducer;